import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
// The app frame and dashboard (2026-10 design) — after Bootstrap so its rules win
import "./styles/feedShell.css";
import "./styles/feedServices.css";
// Sign-in and Register pages (2026-10 design); each is scoped to its page (.fw-login / .fw-register)
import "./styles/authLogin.css";
import "./styles/authRegister.css";
// News & Alerts: the dashboard card, the FPO reminder banner and Administration → News & Alerts
import "./styles/newsAlerts.css";
// Administration → Directory suggestions (from the website's My Directory)
import "./styles/directorySuggestions.css";
import { AuthProvider } from "./Context/AuthContext";
import { BrowserRouter } from "react-router-dom";
import { loadBrand } from "./config/brand";
import { NotificationProvider } from "./Context/NotificationContext";
import ErrorBoundary from "./Components/ErrorBoundary";

// The organisation's name from the website (Header & footer): the tab title and every <BrandName />
loadBrand();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <AuthProvider>
        <BrowserRouter>
          <NotificationProvider>
            <App />
          </NotificationProvider>
        </BrowserRouter>
      </AuthProvider>
    </ErrorBoundary>
  </React.StrictMode>
);

reportWebVitals();
